export default __webpack_public_path__ + "static/media/faq_img.94a2768b.png";